module.exports = __webpack_public_path__ + "media/images/logo/phinoe-5aadb2d719437a193561d2044693a754.png";